<template>
	<div class="discovery-wrapper">
		<div class="discovery-wrapper-top" v-if="!preloaderVisibility">
			<h2>{{ itemsCount }} Results</h2>
			<router-link class="nav-item btn" to="/discovery/add-new-discovery">Add New</router-link>
		</div>
		<div class="discovery-wrapper-sorting">
			<DiscoveryTableSorting
				@on-sorting-change="handleOnSortingChange"
			/>
		</div>
		<div class="discovery-wrapper-table">
			<DiscoveryTableList
				class="discovery-table"
				v-if="!preloaderVisibility"
				:discoveries="discoveries"
			/>
			<PreloaderComponent v-if="preloaderVisibility"/>
		</div>
		<div class="discovery-wrapper-navigation">
			<div>
				<DiscoveryTablePrevButton
					@on-prev-button-click="handleNavigationButtonClick"
					v-if="!preloaderVisibility"
					:offset="searchParams.offset"
					:limit="searchParams.limit"
				/>
			</div>
			<div>
				<DiscoveryTableNextButton
					@on-next-button-click="handleNavigationButtonClick"
					v-if="!preloaderVisibility"
					:offset="searchParams.offset"
					:maxItems="itemsCount"
					:limit="searchParams.limit"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import debounce from 'debounce'

import SolFileAPIInstance from '@/api'
import PreloaderComponent from '@/components/common/PreloaderComponent'
import DiscoveryTableSorting from './DiscoveryTableSorting/DiscoveryTableSorting'
import DiscoveryTableList from '@/components/DiscoveryTable/DiscoveryTableList.vue'
import DiscoveryTableNextButton from '@/components/DiscoveryTable/DiscoveryTableNextButton'
import DiscoveryTablePrevButton from '@/components/DiscoveryTable/DiscoveryTablePrevButton'

export default {
	name: "DiscoveryTable",
	data() {
		return {
			discoveries: [],
			searchParams: {
				offset: 0,
				limit: 10,
				sortingParams: []
			},
			itemsCount: 0,
			preloaderVisibility: true,
		}
	},
	components: {
		DiscoveryTableList,
		PreloaderComponent,
		DiscoveryTableSorting,
		DiscoveryTableNextButton,
		DiscoveryTablePrevButton
	},

	async mounted() {
		await this.fetchDiscoveries()
	},

	methods: {

		fetchDiscoveries: debounce( async function () {
			const response = await SolFileAPIInstance.getDiscoveries(this.searchParams)
			if (response.data) {
				const { discovery, total } = response.data
				this.preloaderVisibility = false
				this.discoveries = discovery
				this.itemsCount = total
			}
		}, 700),

		handleNavigationButtonClick(offset) {
			this.preloaderVisibility = true
			this.searchParams.offset = offset
		},

		handleOnSortingChange(data) {
			this.preloaderVisibility = true
			this.searchParams.sortingParams = data.map(item => ({
				value: item.currentValue,
				type: item.label
			}))
			this.searchParams.offset = 0
			this.fetchDiscoveries()
		}

	},

	watch: {
		searchParams: {
			deep: true,
			handler() {
				this.fetchDiscoveries()
			}
		}
	}

}

</script>

<style scoped lang="scss">

.discovery-wrapper {
	padding: 25px;

	&-table {
		margin-top: 20px;
	}

	&-top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		min-height: 66px;
	}

	.discovery-wrapper-navigation {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
}
</style>